import { render } from "./welcoming-new-joiners.vue?vue&type=template&id=78723a52&scoped=true&lang=pug"
import script from "./welcoming-new-joiners.vue?vue&type=script&lang=js"
export * from "./welcoming-new-joiners.vue?vue&type=script&lang=js"

import "./welcoming-new-joiners.vue?vue&type=style&index=0&id=78723a52&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78723a52"]])

export default __exports__